import {FC} from 'react';
import {LeftSecondMenu} from "../../barsEnvironment/leftMenu/components/leftSecondMenu";
import {Routes} from "./routes";


export const NewIntegrations:FC = () => {
    // useIntegrationsMain();
    return(
        <LeftSecondMenu>
            <Routes/>
        </LeftSecondMenu>
    )
}
